
// import { useEffect, useState } from "react";
// import "../styles/ScanHistory.css";
// import DetailModal from "./DetailModal";
// // "http://127.0.0.1:8000"

// const BACKEND_URL = "https://backend-ml-malware-detection-and-analysis.onrender.com";

// export default function ScanHistory({ newReport }) {
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedReport, setSelectedReport] = useState(null);

//   // Normalize reports
//   const normalizeReport = (r) => ({
//     ...r,

//     filename: r.filename ?? "N/A",

//     type:
//       r.type ??
//       (r.results ? "compare" : "single"),

//     results: r.results ?? null,

//     prediction:
//       r.prediction ??
//       r.results?.xgboost?.prediction ??
//       "N/A",

//     probability:
//       r.probability ??
//       r.results?.xgboost?.probability ??
//       0,

//     model_used: r.model_used ?? null,

//     timestamp: r.timestamp ?? Date.now(),
//   });

//   // Fetch reports from backend
//   const fetchReports = async () => {
//     try {
//       setLoading(true);

//       const response = await fetch(
//         `${BACKEND_URL}/api/reports`
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch reports");
//       }

//       const data = await response.json();

//       const mergedReports = [
//         ...(data.single_reports || []).map((r) => ({
//           ...r,
//           type: "single",
//         })),

//         ...(data.compare_reports || []).map((r) => ({
//           ...r,
//           type: "compare",
//         })),
//       ];

//       // Normalize all reports
//       setReports(
//         mergedReports.map(normalizeReport)
//       );
//     } catch (error) {
//       console.error(
//         "Error fetching reports:",
//         error
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchReports();
//   }, []);

//   // Refresh reports when new scan is added
//   useEffect(() => {
//     if (newReport) {
//       fetchReports();
//     }
//   }, [newReport]);

//   // Status helper
//   const getStatus = (r) => {
//     if (r.type === "single") {
//       return r.prediction?.toLowerCase() ===
//         "malware"
//         ? "Malware"
//         : "Clean";
//     }

//     const rf =
//       r.results?.random_forest?.prediction?.toLowerCase();

//     const xgb =
//       r.results?.xgboost?.prediction?.toLowerCase();

//     return rf === "malware" || xgb === "malware"
//       ? "Malware"
//       : "Clean";
//   };

//   // Delete report
//   const handleDelete = async (id) => {
//     if (!id) return;

//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this report?"
//     );

//     if (!confirmDelete) return;

//     try {
//       const response = await fetch(
//         `${BACKEND_URL}/api/reports/${id}`,
//         {
//           method: "DELETE",
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Delete failed");
//       }

//       setReports((prev) =>
//         prev.filter(
//           (r) =>
//             (r._id?.$oid ||
//               r._id ||
//               r.id) !== id
//         )
//       );
//     } catch (error) {
//       console.error("DELETE ERROR:", error);
//     }
//   };

//   return (
//     <section
//       id="history"
//       className="history-section"
//     >
//       <h2 className="section-title">
//         Scan History
//       </h2>

//       {loading ? (
//         <p>Loading scan history...</p>
//       ) : reports.length === 0 ? (
//         <p>No scan history available.</p>
//       ) : (
//         <div className="history-table-container">
//           <table className="history-table">
//             <thead>
//               <tr>
//                 <th>File Name</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {reports.map((r) => (
//                 <tr
//                   key={
//                     r._id?.$oid ||
//                     r._id ||
//                     r.id ||
//                     r.filename
//                   }
//                 >
//                   <td>{r.filename}</td>

//                   <td>
//                     <span
//                       className={
//                         getStatus(r) === "Malware"
//                           ? "status-malware"
//                           : "status-clean"
//                       }
//                     >
//                       {getStatus(r)}
//                     </span>
//                   </td>

//                   <td>
//                     <button
//                       className="details-btn"
//                       onClick={() =>
//                         setSelectedReport(
//                           normalizeReport(r)
//                         )
//                       }
//                     >
//                       Details
//                     </button>

//                     <button
//                       className="delete-btn"
//                       onClick={() =>
//                         handleDelete(
//                           r._id?.$oid ||
//                             r._id ||
//                             r.id
//                         )
//                       }
//                     >
//                       🗑
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Detail Modal */}
//       {selectedReport && (
//         <DetailModal
//           report={selectedReport}
//           onClose={() =>
//             setSelectedReport(null)
//           }
//         />
//       )}
//     </section>
//   );
// }

import { useEffect, useState } from "react";
import "../styles/ScanHistory.css";
import DetailModal from "./DetailModal";
import ConfirmModal from "./ConfirmModal";

const BACKEND_URL =
  "https://backend-ml-malware-detection-and-analysis.onrender.com";

export default function ScanHistory({ newReport }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  // Detail modal
  const [selectedReport, setSelectedReport] =
    useState(null);

  // Delete confirmation modal
  const [showDeleteModal, setShowDeleteModal] =
    useState(false);

  const [deleteId, setDeleteId] =
    useState(null);

  // Normalize reports
  const normalizeReport = (r) => ({
    ...r,

    filename: r.filename ?? "N/A",

    type:
      r.type ??
      (r.results ? "compare" : "single"),

    results: r.results ?? null,

    prediction:
      r.prediction ??
      r.results?.xgboost?.prediction ??
      "N/A",

    probability:
      r.probability ??
      r.results?.xgboost?.probability ??
      0,

    model_used: r.model_used ?? null,

    timestamp: r.timestamp ?? Date.now(),
  });

  // Fetch reports
  const fetchReports = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BACKEND_URL}/api/reports`
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch reports"
        );
      }

      const data = await response.json();

      const mergedReports = [
        ...(data.single_reports || []).map(
          (r) => ({
            ...r,
            type: "single",
          })
        ),

        ...(data.compare_reports || []).map(
          (r) => ({
            ...r,
            type: "compare",
          })
        ),
      ];

      setReports(
        mergedReports.map(normalizeReport)
      );

    } catch (error) {
      console.error(
        "Error fetching reports:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    fetchReports();
  }, []);

  // Refresh after new scan
  useEffect(() => {
    if (newReport) {
      fetchReports();
    }
  }, [newReport]);

  // Status helper
  const getStatus = (r) => {
    if (r.type === "single") {
      return r.prediction?.toLowerCase() ===
        "malware"
        ? "Malware"
        : "Clean";
    }

    const rf =
      r.results?.random_forest?.prediction?.toLowerCase();

    const xgb =
      r.results?.xgboost?.prediction?.toLowerCase();

    return rf === "malware" ||
      xgb === "malware"
      ? "Malware"
      : "Clean";
  };

  // Open delete modal
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // Confirm delete
  const confirmDelete = async () => {
    if (!deleteId) return;

    try {
      const response = await fetch(
        `${BACKEND_URL}/api/reports/${deleteId}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Delete failed");
      }

      // Remove deleted report from UI
      setReports((prev) =>
        prev.filter(
          (r) =>
            (r._id?.$oid ||
              r._id ||
              r.id) !== deleteId
        )
      );

      // Close modal
      setShowDeleteModal(false);
      setDeleteId(null);

    } catch (error) {
      console.error(
        "DELETE ERROR:",
        error
      );
    }
  };

  return (
    <section
      id="history"
      className="history-section"
    >
      <h2 className="section-title">
        Scan History
      </h2>

      {loading ? (
        <p>Loading scan history...</p>

      ) : reports.length === 0 ? (

        <p>No scan history available.</p>

      ) : (

        <div className="history-table-container">
          <table className="history-table">

            <thead>
              <tr>
                <th>File Name</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {reports.map((r) => (
                <tr
                  key={
                    r._id?.$oid ||
                    r._id ||
                    r.id ||
                    r.filename
                  }
                >
                  {/* Filename */}
                  <td>{r.filename}</td>

                  {/* Status */}
                  <td>
                    <span
                      className={
                        getStatus(r) ===
                        "Malware"
                          ? "status-malware"
                          : "status-clean"
                      }
                    >
                      {getStatus(r)}
                    </span>
                  </td>

                  {/* Actions */}
                  <td>

                    {/* Details button */}
                    <button
                      className="details-btn"
                      onClick={() =>
                        setSelectedReport(
                          normalizeReport(r)
                        )
                      }
                    >
                      Details
                    </button>

                    {/* Delete button */}
                    <button
                      className="delete-btn"
                      onClick={() =>
                        handleDeleteClick(
                          r._id?.$oid ||
                            r._id ||
                            r.id
                        )
                      }
                    >
                      🗑
                    </button>

                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      )}

      {/* Detail Modal */}
      {selectedReport && (
        <DetailModal
          report={selectedReport}
          onClose={() =>
            setSelectedReport(null)
          }
        />
      )}

      {/* Confirm Delete Modal */}
      <ConfirmModal
        show={showDeleteModal}
        title="Delete Report"
        message="Are you sure you want to delete this scan report? This action cannot be undone."
        onConfirm={confirmDelete}
        onCancel={() =>
          setShowDeleteModal(false)
        }
      />
    </section>
  );
}
